<template>
	<section>
		<b-row>
			<b-col>
				<b-img v-b-tooltip.hover title="Eamon Hurley's rotary powered drag-bike" alt="Eamon Hurley's rotary powered drag-bike" fluid  :src="require('../assets/eamon-hurley-concorde-rotary-drag-bike.png')" class="rounded-0"></b-img>
				<h1 class="h2 mt-2 text-uppercase">Our History</h1>
				<p>
					HME was established by Eamon Hurley in the late '70s originally transplanting NSU Ro80 engines to Ford V4-V6 powerplants as an affordable alternative. With Eamons drag-racing background, it wasn't long before he decided to build a top-fueled drag-bike with all the broken engines. In the early '80s, the Concorde was campaigned very successfully, clocking regular 8s runs.
				</p>
				<p>
					Many of the ideas and knowledge gained from Concorde are used to benefit our customers this very day. With that, people began approaching us to look after their MAZDA RX motors. Hence, where we are today.
				</p>
			</b-col>
		</b-row>
	</section>
</template>
<script>
export default {
  name: 'OurHistory',
  props: {
    msg: String
  }
}
</script>